import React from "react";
import RollerSwitcher from "../../../components/common/RollerSwitcher/RollerSwitcher";
import noImage from "../../../assets/images/no-image.jpg";

const JoinPosterAssortmentContent = ({ productsData, onToggleProduct }) => {
  const productsList = productsData?.results || [];

  return (
    <div className="JoinPosterAssortmentContentWrap">
      <div className="JoinPosterAssortmentContent__spacer" />
      <div className="JoinPosterAssortmentContentPanel JoinPosterAssortmentPanel">
        <div className="JoinPosterAssortmentPanel__header">
          <span>Товари</span>
          <span>Відображати{"\n"}в застосунку</span>
        </div>
        <div className="JoinPosterAssortmentPanel__body">
          {productsList.length === 0 && (
            <div className="JoinPosterAssortmentContent__empty">
              Товарів по даному фільтру не знайдено...
            </div>
          )}
          {productsList.length > 0 && (
            <div className="JoinPosterAssortmentProducts">
              {productsList.map((product) => {
                const imgSrc = product.jpImg || product.img || noImage;
                const title =
                  product.jpTitle || product.t || product.name || "Без назви";
                const isActive =
                  product.jpIsAppVisible ??
                  product.appvisible ??
                  product.appVisible ??
                  product.isAppVisible ??
                  false;
                return (
                  <div
                    className="JoinPosterAssortmentProductCard"
                    key={product.id}
                  >
                    <div className="JoinPosterAssortmentProductInfo">
                      <img
                        className="JoinPosterAssortmentProductImage"
                        src={imgSrc}
                        alt=""
                        onError={(event) => {
                          event.currentTarget.src = noImage;
                        }}
                      />
                      <span className="JoinPosterAssortmentProductTitle">
                        {title}
                      </span>
                    </div>
                    <div className="JoinPosterAssortmentProductSwitch">
                      <RollerSwitcher
                        isActive={!!isActive}
                        bgColor="#9978e2"
                        onClickAction={() =>
                          onToggleProduct &&
                          onToggleProduct(product, !isActive)
                        }
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default JoinPosterAssortmentContent;
